const o = {
  "two-column-layout": "two-column-layout",
  "two-column-layout--top": "two-column-layout--top",
  "two-column-layout--bottom": "two-column-layout--bottom",
  "two-column-layout__column": "two-column-layout__column",
  "two-column-layout__column--right": "two-column-layout__column--right",
  "two-column-layout__column--center": "two-column-layout__column--center",
  "two-column-layout__column--fill": "two-column-layout__column--fill"
};
export {
  o as default
};
